import React, { useState, useEffect } from 'react'
import './styles/Table.css'
import MaterialTable from 'material-table'

import DownloadIcon from '@mui/icons-material/Download'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { Grid, Modal, Button, FormControl, TextField } from '@material-ui/core'
import Typography from '@mui/material/Typography'
import Swal from 'sweetalert2'
import swal from 'sweetalert'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

import ROUTES from '../../../../../routers/routes'
import { useHistory } from 'react-router-dom'
import { useAuthentication } from '../../../../../context/authenticationContext'
import { useForm } from '../../../../../context/formContext'
import { getFormulariosDraftIFIS } from '../../../../../services/IFI/get'
import { deletePrelegibilidad } from '../../../../../services/IFI/delete'
import { DeleteElibilityForm } from '../../../../../services/Elegibilidad/delete'
import { deleteFormTechnicalAssistanceAnswers } from '../../../../../services/AsistenciaTecnica/delete'
import {
  MasterLimitsAvailable,
  reportCapacityBuilding,
  reportCapacityBuildingGroupMipyme,
  reportCapacityBuildingIFI,
  reportTechnicalAssistancePreinvestment,
  reportTechnicalAssistancePreinvestmentGroupMipyme,
} from '../../../../../services/AsistenciaTecnica/create'
import { getReportWithPlan } from '../../../../../services/Elegibilidad/get'
import {
  infoValidateEditForm,
  validateEditForm,
} from '../../../../../services/Forms/create'
import { deleteMonotoringAndEvaluation } from '../../../../../services/MonitoreoYEvaluacion/delete'

const TableFormularios = () => {
  const [loading, setLoading] = useState(true)
  const [IdFormObsv, setIdFormObsv] = useState([])
  const [ObservationForm, setObservationForm] = useState([])
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    setOpen(false)
    setObservationForm('')
    setIdFormObsv(0)
  }
  const handleEditar = (idForm) => {
    if (FormType === 1) {
      history.push(ROUTES.IFIEDITAR.pathname, IdFormObsv)
    } else if (FormType === 3 || FormType === 4 || FormType === 5) {
      history.push(ROUTES.ASISTENCIATECNICAEDITAR.pathname, {
        idForm: IdFormObsv,
        edit: true,
      })
    } else {
      history.push(ROUTES.IFIEDITARELEGIBILIDAD.pathname, IdFormObsv)
    }
  }

  const validateMasterAssistance = async (idForm) => {
    try {
      const response = await MasterLimitsAvailable(2)
      if (response.Success) {
        history.push(ROUTES.ASISTENCIATECNICAEDITAR.pathname, {
          idForm: idForm,
          edit: true,
        })
      } else {
        swal({
          title: `Ha ocurrido un problema`,
          text: `La disponibilidad de fondos de asistencia técnica se ha agotado`,
          icon: `error`,
          closeOnClickOutside: false,
          closeOnEsc: false,
          buttons: {
            catch: {
              text: 'Continuar',
              value: 'catch',
            },
          },
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const validateMasterElegibilidad = async (idForm) => {
    try {
      const response = await MasterLimitsAvailable(1)
      if (response.Success) {
        history.push(ROUTES.IFIEDITARELEGIBILIDAD.pathname, idForm)
      } else {
        swal({
          title: `Ha ocurrido un problema`,
          text: `La disponibilidad de fondos de crédito se ha agotado`,
          icon: `error`,
          closeOnClickOutside: false,
          closeOnEsc: false,
          buttons: {
            catch: {
              text: 'Continuar',
              value: 'catch',
            },
          },
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getInProcessForms()
  }, [])
  const { downloadPreIFIPDF } = useForm()
  const getInProcessForms = async () => {
    try {
      const response = await getFormulariosDraftIFIS(IdIFIToken)
      if (response.Success) {
        if (response.Data.length > 0) {
          setTableForms(response.Data)
        } else {
          setTableForms([])
        }
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
    setLoading(false)
  }

  const columns = [
    // {
    //   title: 'IdForm',
    //   field: 'IdForm',
    //   sorting: true,
    //   filtering: true,
    //   // cellStyle: { background: '#009688' },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Fecha',
      field: 'Fecha_Envío_a_Revisión',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'date',
    },
    {
      title: 'Formulario',
      field: 'FormType',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Estado del formulario',
      field: 'Estado',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Código del Proyecto',
      field: 'Código_Proyecto',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Nombre del Proyecto',
      field: 'Nombre_del_Proyecto',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Etapa del Proyecto',
      field: 'Etapa',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'MIPYME o IFI',
      field: 'Applicant',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Condición MIPYME',
      field: 'MipymeCondition',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Estado MIPYME',
      field: 'MiPymeStatus',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]
  const history = useHistory()
  const [TableForms, setTableForms] = useState([])
  const [FormType, setFormType] = useState([])
  const { IdIFIToken, userIDB2C } = useAuthentication()

  const eliminateDraftForm = (idForm, formStage) => {
    if (
      idForm !== '' &&
      idForm !== undefined &&
      idForm !== null &&
      formStage === 'Formulario Pre-Elegibilidad'
    ) {
      Swal.fire({
        title: '¿Está Seguro?',
        text: '¡Esta acción no es reversible!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deletePrelegibilidad(idForm)

          if (response.Data.Message === false) {
            swal({
              title: `Eliminado`,
              text: `El formulario ha sido eliminado con éxito`,
              icon: `success`,
              closeOnClickOutside: false,
              closeOnEsc: false,
              buttons: {
                catch: {
                  text: 'Entendido',
                  value: 'catch',
                },
              },
            }).then((value) => {
              switch (value) {
                case 'catch':
                  swal.close()
                  break
                default:
                  swal.close()
              }
            })
          } else {
            swal({
              title: `Error`,
              text: `${response.Data.MessageInfo.Message}`,
              icon: `error`,
              closeOnClickOutside: false,
              closeOnEsc: false,
              buttons: {
                catch: {
                  text: 'Entendido',
                  value: 'catch',
                },
              },
            }).then((value) => {
              switch (value) {
                case 'catch':
                  swal.close()
                  break
                default:
                  swal.close()
              }
            })
          }
        }
        getInProcessForms()
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Se ha producido un error desconocido. Por favor, póngase en contacto con el soporte técnico para obtener ayuda',
        footer:
          '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
      })
    }

    if (
      idForm !== '' &&
      idForm !== undefined &&
      idForm !== null &&
      formStage === 'Formulario Elegibilidad'
    ) {
      Swal.fire({
        title: '¿Está Seguro?',
        text: '¡Esta acción no es reversible!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await DeleteElibilityForm(idForm, userIDB2C)

          if (response.Code === 200) {
            swal({
              title: `Eliminado`,
              text: `El formulario ha sido eliminado con éxito`,
              icon: `success`,
              closeOnClickOutside: false,
              closeOnEsc: false,
              buttons: {
                catch: {
                  text: 'Okay',
                  value: 'catch',
                },
              },
            }).then((value) => {
              switch (value) {
                case 'catch':
                  swal.close()
                  break
                default:
                  swal.close()
              }
            })
          } else {
            swal({
              title: `Error`,
              text: `${response.Message}`,
              icon: `warning`,
              closeOnClickOutside: false,
              closeOnEsc: false,
              buttons: {
                catch: {
                  text: 'Okay',
                  value: 'catch',
                },
              },
            }).then((value) => {
              switch (value) {
                case 'catch':
                  swal.close()
                  break
                default:
                  swal.close()
              }
            })
          }
        }
        getInProcessForms()
      })
    }

    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      (formStage === 'Asistencia Técnica para Preinversión MIPYME' ||
        formStage ===
          'Asistencia Técnica para Construcción de Capacidades MIPYME' ||
        formStage === 'Asistencia Técnica para Construcción de Capacidades IFI')
    ) {
      Swal.fire({
        title: '¿Está Seguro?',
        text: '¡Esta acción no es reversible!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteFormTechnicalAssistanceAnswers(
            idForm,
            userIDB2C,
          )

          if (response.Code === 200) {
            swal({
              title: `Eliminado`,
              text: `El formulario ha sido eliminado con éxito`,
              icon: `success`,
              closeOnClickOutside: false,
              closeOnEsc: false,
              buttons: {
                catch: {
                  text: 'Okay',
                  value: 'catch',
                },
              },
            }).then((value) => {
              switch (value) {
                case 'catch':
                  swal.close()
                  break
                default:
                  swal.close()
              }
            })
          } else {
            swal({
              title: `Error`,
              text: `${response.Message}`,
              icon: `warning`,
              closeOnClickOutside: false,
              closeOnEsc: false,
              buttons: {
                catch: {
                  text: 'Okay',
                  value: 'catch',
                },
              },
            }).then((value) => {
              switch (value) {
                case 'catch':
                  swal.close()
                  break
                default:
                  swal.close()
              }
            })
          }
        }
        getInProcessForms()
      })
    }

    if (
      (idForm !== '' &&
        idForm !== undefined &&
        idForm !== null &&
        formStage === 'Formulario de Medio Término') ||
      formStage === 'Formulario de Final Término'
    ) {
      Swal.fire({
        title: '¿Está Seguro?',
        text: '¡Esta acción no es reversible!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteMonotoringAndEvaluation(
            idForm,
            userIDB2C,
          )

          if (response.Code === 200) {
            swal({
              title: `Eliminado`,
              text: `El formulario ha sido eliminado con éxito`,
              icon: `success`,
              closeOnClickOutside: false,
              closeOnEsc: false,
              buttons: {
                catch: {
                  text: 'Okay',
                  value: 'catch',
                },
              },
            }).then((value) => {
              switch (value) {
                case 'catch':
                  swal.close()
                  break
                default:
                  swal.close()
              }
            })
          } else {
            swal({
              title: `Error`,
              text: `${response.Message}`,
              icon: `warning`,
              closeOnClickOutside: false,
              closeOnEsc: false,
              buttons: {
                catch: {
                  text: 'Okay',
                  value: 'catch',
                },
              },
            }).then((value) => {
              switch (value) {
                case 'catch':
                  swal.close()
                  break
                default:
                  swal.close()
              }
            })
          }
        }
        getInProcessForms()
      })
    }
  }
  const editForm = async (idForm, formStage, correct, obsvations) => {
    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      formStage === 'Formulario Pre-Elegibilidad'
    ) {
      const response = await infoValidateEditForm(userIDB2C, idForm)
      if (response.Success) {
        if (response.Data.Message) {
          swal({
            title: `No se puede ingresar al formulario`,
            text: `${response.Data.MessageInfo[0].Message}`,
            icon: `warning`,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
              catch: {
                text: 'Entendido',
                value: 'catch',
              },
            },
          })
        } else if (response.Data.Message === false) {
          const responseValidate = await validateEditForm(userIDB2C, 1, idForm)
          if (responseValidate.Success) {
            if (correct === true) {
              setFormType(1)
              handleOpen(true)
            } else {
              history.push(ROUTES.IFIEDITAR.pathname, idForm)
            }
          }
        }
      }
    }

    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      (formStage === 'Asistencia Técnica para Preinversión MIPYME' ||
        formStage ===
          'Asistencia Técnica para Construcción de Capacidades MIPYME' ||
        formStage === 'Asistencia Técnica para Construcción de Capacidades IFI')
    ) {
      const response = await infoValidateEditForm(userIDB2C, idForm)
      if (response.Success) {
        console.log(response.Data)
        if (response.Data.Message) {
          swal({
            title: `No se puede ingresar al formulario`,
            text: `${response.Data.MessageInfo[0].Message}`,
            icon: `warning`,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
              catch: {
                text: 'Entendido',
                value: 'catch',
              },
            },
          })
        } else if (response.Data.Message === false) {
          const responseValidate = await validateEditForm(userIDB2C, 1, idForm)
          if (responseValidate.Success) {
            if (correct === true) {
              handleOpen(true)
            } else {
              validateMasterAssistance(idForm)
            }
          }
        }
      }
    }

    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      formStage === 'Formulario Elegibilidad'
    ) {
      // setIdEditForm(idForm)
      // getEditFormElegibility(idForm)
      // if (getEditFormElegibility) {
      // }

      const response = await infoValidateEditForm(userIDB2C, idForm)
      if (response.Success) {
        console.log(response.Data)
        if (response.Data.Message) {
          swal({
            title: `No se puede ingresar al formulario`,
            text: `${response.Data.MessageInfo[0].Message}`,
            icon: `warning`,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
              catch: {
                text: 'Entendido',
                value: 'catch',
              },
            },
          })
        } else if (response.Data.Message === false) {
          const responseValidate = await validateEditForm(userIDB2C, 1, idForm)
          if (responseValidate.Success) {
            if (correct === true) {
              setFormType(2)
              handleOpen(true)
            } else {
              // history.push(ROUTES.IFIEDITARELEGIBILIDAD.pathname, idForm)
              validateMasterElegibilidad(idForm)
            }
          }
        }
      }
    }

    if (
      (idForm !== '' &&
        idForm !== null &&
        idForm !== undefined &&
        formStage === 'Formulario de Medio Término') ||
      formStage === 'Formulario de Final Término'
    ) {
      history.push(ROUTES.MONITOREOYEVALUACION.pathname, {
        idForm: idForm,
        edit: true,
      })
    }
    // if (
    //   idForm !== '' &&
    //   idForm !== null &&
    //   idForm !== undefined &&
    //   formStage === 'Formulario Asistencia Tecnica'
    // ) {
    //   history.push(ROUTES.EDITARELEGIBILIDAD.pathname, idForm)
    // }
  }

  const getPDFWithPlan = async (idForm, projectName) => {
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Generando Archivo',
      text: 'Iniciando descarga',
      showConfirmButton: false,
      timer: 2000,
      allowOutsideClick: false,
    })
    try {
      const response = await getReportWithPlan(idForm)

      if (response.Success) {
        const byteCharacters = atob(response.Data.Report)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const filename = `Formulario - ${projectName}`
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const downloadReportAssistance = async (
    idForm,
    formStage,
    IdBeneficiaryType,
  ) => {
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Generando Archivo',
      text: 'Iniciando descarga',
      showConfirmButton: false,
      timer: 2000,
      allowOutsideClick: false,
    })

    try {
      let response

      if (IdBeneficiaryType === 2)
        response = await reportCapacityBuildingIFI(idForm, userIDB2C)

      if (
        IdBeneficiaryType === 1 &&
        formStage === 'Asistencia Técnica para Preinversión MIPYME'
      )
        response = await reportTechnicalAssistancePreinvestment(
          idForm,
          userIDB2C,
        )

      if (
        IdBeneficiaryType === 3 &&
        formStage === 'Asistencia Técnica para Preinversión MIPYME'
      )
        response = await reportTechnicalAssistancePreinvestmentGroupMipyme(
          idForm,
          userIDB2C,
        )

      if (
        IdBeneficiaryType === 1 &&
        formStage ===
          'Asistencia Técnica para Construcción de Capacidades MIPYME'
      )
        response = await reportCapacityBuilding(idForm, userIDB2C)

      if (
        IdBeneficiaryType === 3 &&
        formStage ===
          'Asistencia Técnica para Construcción de Capacidades MIPYME'
      )
        response = await reportCapacityBuildingGroupMipyme(idForm, userIDB2C)

      if (response.Success) {
        for (
          let j = 0;
          j < response.Data.ReportTechnicalAssistanceAnswers.length;
          j++
        ) {
          const byteCharacters = atob(
            response.Data.ReportTechnicalAssistanceAnswers[j].FileContents,
          )
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const filename =
            response.Data.ReportTechnicalAssistanceAnswers[j].FileName.split(
              '.',
            ).shift()
          const blob = new Blob([byteArray], { type: 'application/pdf' })
          const link = document.createElement('a')

          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const DownloadForm = (idForm, formStage, projectName, IdBeneficiaryType) => {
    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      formStage === 'Formulario Pre-Elegibilidad'
    ) {
      downloadPreIFIPDF(idForm, undefined, projectName)
    }
    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      formStage === 'Formulario Elegibilidad'
    ) {
      getPDFWithPlan(idForm, projectName)
    }

    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      (formStage === 'Asistencia Técnica para Preinversión MIPYME' ||
        formStage ===
          'Asistencia Técnica para Construcción de Capacidades MIPYME' ||
        formStage === 'Asistencia Técnica para Construcción de Capacidades IFI')
    ) {
      downloadReportAssistance(idForm, formStage, IdBeneficiaryType)
    }
  }

  return (
    <section>
      {!loading ? (
        <Grid
          container
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: 'auto',
              width: '96%',
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
          >
            <div className="App">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <MaterialTable
                    columns={columns}
                    data={TableForms}
                    actions={[
                      {
                        icon: () => <EditIcon color="primary" />,
                        tooltip: 'Editar',
                        onClick: (event, rowData) => {
                          editForm(
                            rowData.IdForm,
                            rowData.FormType,
                            rowData.Correct,
                            rowData.Observations,
                          )
                          setIdFormObsv(rowData.IdForm)
                          setObservationForm(rowData.Observations)
                          setFormType(rowData.IdFormType)
                        },
                      },
                      {
                        icon: () => <DeleteIcon color="error" />,
                        tooltip: 'Eliminar registro',
                        onClick: (event, rowData) => {
                          eliminateDraftForm(rowData.IdForm, rowData.FormType)
                        },
                      },

                      {
                        icon: () => <DownloadIcon color="success" />,
                        tooltip: 'Descargar PDF',
                        onClick: (event, rowData) => {
                          DownloadForm(
                            rowData.IdForm,
                            rowData.FormType,
                            rowData.Nombre_del_Proyecto,
                            rowData.IdBeneficiaryType,
                          )
                        },
                      },
                    ]}
                    onSelectionChange={(selectedRows) =>
                      console.log(selectedRows)
                    }
                    options={{
                      sorting: true,
                      search: true,
                      searchFieldAlignment: 'right',
                      searchAutoFocus: true,
                      searchFieldVariant: 'standard',
                      filtering: true,
                      paging: true,
                      pageSizeOptions: [2, 5, 10, 20],
                      pageSize: 5,
                      paginationType: 'stepped',
                      showFirstLastPageButtons: false,
                      paginationPosition: 'bottom',
                      exportButton: true,
                      exportAllData: true,
                      exportFileName:
                        'BCIE - Cambio II                     Consulta Formularios',
                      // addRowPosition: 'first',
                      actionsColumnIndex: -1,
                      selection: false,
                      showSelectAllCheckbox: false,
                      showTextRowsSelected: false,
                      selectionProps: (rowData) => ({
                        disabled: rowData.age == null,
                        // color:"primary"
                      }),
                      // grouping: true,
                      // columnsButton: f,
                      rowStyle: (data, index) =>
                        index % 2 === 0 ? { background: '#f5f5f5' } : null,
                      headerStyle: { background: '#014b96', color: '#fff' },
                    }}
                    localization={{
                      body: {
                        editRow: {
                          deleteText: '¿Está seguro de eliminar el registro?',
                        },
                        emptyDataSourceMessage: 'No hay registros a desplegar',
                      },
                      header: {
                        actions: 'Acciones',
                      },
                      toolbar: {
                        searchPlaceholder: 'Buscar',
                      },
                    }}
                    title=" "
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <Grid className="modalTitle">
            <Typography
              id="modal-modal-title"
              style={{ fontWeight: '900' }}
              variant="h6"
              component="h2"
            >
              Observaciones
            </Typography>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid
              container
              spacing={1}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
              }}
            >
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Correciones por realizar en tu formulario.
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <textarea
                          id="Observation"
                          name="Observation"
                          placeholder="Observaciones"
                          customInput={TextField}
                          inputProps={{ maxLength: 250 }}
                          value={ObservationForm}
                          disabled
                        ></textarea>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  onClick={() => handleEditar()}
                >
                  Editar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </section>
  )
}
export default TableFormularios
